<template>
  <div class="magazine-send">
    <navigator :items="items"></navigator>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="container-fluid">
              <div class="row">
                <div class="col-12">
                  <div class="title-section">Dados do Envio</div>
                </div>
              </div>
              <div class="row title-row">
                <div class="col-lg-6 col-12 title-col">
                  <span>Revista</span>
                </div>
                <div class="col-lg-6 col-12 title-col">
                  <span>Edição</span>
                </div>
              </div>
              <div class="row" v-for="magazine in magazines" v-bind:key="magazine.id">
                <div class="col-lg-6 col-12">
                  <div class="d-flex align-items-center justify-content-end toggle-input">
                    <label for>{{magazine.name}}</label>
                    <toggle-button v-model="magazine.send" v-bind:key="magazine.send" />
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="d-flex align-items-center justify-content-end h-100">
                    <select
                      class="form-control"
                      v-model="magazine.edition_selected"
                      :disabled="!magazine.send"
                      v-bind:key="magazine.send"
                    >
                      <!-- <option value="0" v-if="!magazine.send"></option> -->
                      <option
                        v-for="edition in magazine.latest_editions"
                        v-bind:key="edition.id"
                        :value="edition.id"
                      >
                        <span
                          v-if="magazine.send"
                        >{{`${getMonthLabel(edition.month)} ${edition.year} - nº ${edition.edition_number}`}}</span>
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <button class="btn btn-primary float-right" v-on:click="save()">Salvar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/api/axios";
import Swal from "sweetalert2";
import { bus } from "@/main";

export default {
  name: "magazine-send",
  data() {
    return {
      createParams: [],
      magazines: [],
      magazine_editions_ids: [],
      items: [
        {
          text: "Edições enviadas",
          route: "admin.magazines-sends"
        },
        {
          text: "Novo Envio",
          active: true
        }
      ]
    };
  },
  mounted() {
    this.getCreateParams();
  },
  methods: {
    getCreateParams: function() {
      axios
        .get(`${process.env.VUE_APP_API_HOST}/api/magazine_send/create`)
        .then(data => {
          this.createParams = data.data;
          this.magazines = this.createParams.magazines;
          this.magazines.forEach(el => {
            // el.send = false,
            el.edition_selected = el.latest_editions[0].id;
          });
        });
    },
    getMonthLabel: function(value) {
      if (value == "1") return "Janeiro";
      if (value == "2") return "Fevereiro";
      if (value == "3") return "Março";
      if (value == "4") return "Abril";
      if (value == "5") return "Maio";
      if (value == "6") return "Junho";
      if (value == "7") return "Julho";
      if (value == "8") return "Agosto";
      if (value == "9") return "Setembro";
      if (value == "10") return "Outubro";
      if (value == "11") return "Novembro";
      if (value == "12") return "Dezembro";
    },
    save: function() {
      this.magazine_editions_ids = [];
      this.magazines.forEach(el => {
        if (el.send) {
          this.magazine_editions_ids.push(el.edition_selected);
        }
      });

      if (this.magazine_editions_ids.length > 0) {
        axios
          .post(`${process.env.VUE_APP_API_HOST}/api/magazine_send`, {'editions': this.magazine_editions_ids})
          .then(response => {
            if (response.data.id) {
              bus.$emit("changeLoading", false);
              Swal.fire({
                title: "Novo Envio cadastrado",
                icon: "success",
                onClose: () => {
                  this.$router.push({ name: "admin.magazines-sends" });
                }
              });
            }
          })
          .catch(error => {
            bus.$emit("changeLoading", false);
            Swal.fire({
              title: "Ocorreu um erro.",
              icon: "error"
            });
          });
      } else {
        Swal.fire({
          title: "Atenção",
          text: "É preciso selecionar ao menos uma edição",
          icon: "warning"
        });
      }
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/General.scss";

.magazine-send {
  .toggle-input {
    padding: 4vh 0;
    label {
      margin-right: 2vw;
    }
  }
  .title-row {
    margin-top: 1vh;
    margin-bottom: 1vh;
    .title-col {
      text-align: center;
      font-size: 18px;
      font-weight: 600;
    }
  }
}
</style>